export enum ApplicationApiUrls {
  // Authentication
  Login = '/Auth/login',
  ChangeExpiredPassword = '/Auth/ChangeExpiredPassword',
  AppleLogin = '/Auth/AppleLogin',
  GoogleLogin = '/Auth/GoogleLogin',
  TwoStepVerification = '/Auth/TwoStepVerification',
  ResetPassword = '/Auth/ResetPassword',
  ForgotPassword = '/Auth/ForgotPassword',
  DeleteAccount = '/Auth/DeleteAccount',

  // Account Management
  CreateUser = '/Auth/Register',
  GetMyProfile = '/Account/GetMyProfile',
  UpdateProfile = '/Account/UpdateProfile',
  UpdateProfileImage = '/Account/UpdateProfileImage',
  switchRole = '/Auth/SwitchRole',

  // Lookups
  GetAmenities = '/Lookup/get-all-amenities',
  GetPropertyTypes = '/Lookup/get-property-types',
  GetAllRoles = '/Lookup/get-roles',

  // Property Profile Management
  AddListing = '/PropertyProfile/CreateProperty',
  SaveAsDraft = '/PropertyProfile/CreatePropertyProfileAsDraft', //to be deleted
  UpdateDraft = '/PropertyProfile/UpdatePropertyAsDraft', //to be deleted
  EditListing = '/PropertyProfile/CreatePropertyProfile', //to be deleted
  GetListings = '/PropertyProfile/search/advanced',
  GetPropertyProfileById = '/PropertyProfile/',
  SetPropertyProfileStatus = '/PropertyProfile/{id}/status',
  DeleteProperty = '/PropertyProfile/DeleteProperty',

  // contact Queries
  GetContactQueries = '/ContactUs/GetContactUs',

  //blogs
  AddUpdateBlog = '/Blog/CreateUpdateBlog',
  GetBlogs = '/Blog/GetAllBlogs',
  GetBlogById = '/Blog/GetBlog',
  DeleteBlog = '/Blog/DeleteBlog',

  // Reviews
  GetReviewByPropertyProfileId = '/Review/property/',
  GetAllReview = '/Review',
  CreateReview = '/Review',

  // Dashboard
  DashBoardCardsForAdmin = '/DashBoard/DashBoardCardsForAdmin',
  DashBoardCardsForHost = '/DashBoard/DashBoardCardsForHost',
  AdminDashBoardCard = '/Admin/AdminDashBoardCard',
  AdminDashBoardBookingCard = '/Admin/AdminDashBoardBookingCard',
  AdminRevenueChart = '/Admin/GetAdminRevenue',
  AdminBookingSummaryChart = '/Admin/BookingSummary',
  HostRevenueChart = '/DashBoard/Mobile-Host-GetRevenue?type=monthly',

  // Booking Management
  BookingReservation = '/Booking/BookingReservation',
  GetAllMyBooking = '/Booking/GetAllUserBooking',
  GetUnavailableDates = '/Booking/GetUnavailableDates',
  GetAllOwnerPropertyProfileBooking = '/Booking/GetAllOwnerPropertyProfileBooking',
  GetAllAdminBooking = '/Admin/GetAllAdminBooking',
  GetAllHostBooking = '/Booking/GetAllHostBooking',

  // User Management
  GetAllUser = '/Admin/GetAllUser',

  // Payouts
  GetAllPayout = '/Payouts',
  CreatePayout = '/Payouts',
  GetPayoutById = '/Payouts/',
  GetAllAdminPayout = '/Payouts/admin',

  // Wallet Management
  GetWalletInfo = '/Wallet',
  GetAllSalesTransactions = '/Wallet/transactions',
  GetAllProviderSale = '/Wallet/providers/sales',
  GetAllProviderEarnings = '/Wallet/providers/earnings',
  GetAllAdminEarnings = '/Wallet/admin/earnings',
  HostRemainingWalletBalance = '/Wallet/Host/balance',
  WalletHostCard = '/Wallet/host-card',
  GetAllProviderEarningById = 'Wallet/invoices/',

  // User Bank Account Management
  CreateUpdateBankInfo = '/UserBankAccount/CreateUpdateBankInfo',
  GetUserBankInfo = '/UserBankAccount/GetUserBankInfo',

  //Career and Investors
  ContactUs = '/ContactUs/ContactUs',

  // Blog
  GetAllBlogs = '/Blog/GetAllBlogs',

  // Wishlist
  Wishlist = '/Wishlist',
  GetWishlistPaged = '/Wishlist',
  AddWishlistItem = '/Wishlist/add/{listingId}',
  RemoveWishlistItem = '/Wishlist/remove/{listingId}',
  GetUserWishlistPropertyIds = '/Wishlist/GetUserWishlistPropertyIds',
}
